<template>
  <div class="navigator">
    <img
      class="back-icon"
      :src="lightBg ? icon['back-1'] : icon['back']"
      @click="$router.back()"
    />
    <p class="title" :class="{ 'title-1': lightBg }">
      {{ $route.name }}
    </p>
    <i class="holder"></i>
  </div>
</template>

<script>
export default {
  name: 'Navigator',
  data() {
    return {
      icon: {
        'back': require('@/assets/image/back.png'),
        'back-1': require('@/assets/image/back-1.png')
      }
    }
  },
  computed: {
    lightBg() {
      const {
        meta
      } = this.$route

      return meta && meta.opacity <= 0.3
    }
  }
}
</script>

<style lang="less" scoped>
  .navigator {
    height: 174px;
    display: flex;
    padding: 0 40px;
    justify-content: space-between;
    align-items: center;
    .back-icon, .holder {
      width: 96px;
      height: auto;
    }
    .title {
      color: @primary-font-color-1;
      font-size: 48px;
      font-weight: bold;
      flex: 1;
      text-align: center;
    }
    .title-1 {
      color: @font-black-1;
    }
  }
</style>